(ns kyber.components.composite.scrubber
  (:require [re-frame.core :as re-frame]

            [kyber.utils :refer [get-video-progress]]
            [kyber.styles.core :refer [styles->classes]]))

(def classes
  (styles->classes
   {:scrubber-container
    {:width "100%"}}))

(defn render
  {:doc "Player control (Scrub Video)"
   :id :scrub-media-control
   :version 0
   :variant :a}
  [{:keys [player-key player-attributes]}]
  (let [progress (get-video-progress player-attributes)]
    [:input {:type :range
             :min 0
             :max 100
             :value (str progress)
             :class (:scrubber-container classes)
             :on-change (fn [e]
                          (let [position (* (:duration @player-attributes)
                                            (-> e
                                                .-target
                                                .-value
                                                (/ 100)))]
                            (re-frame/dispatch
                             [:media-player/seek {:player-key player-key
                                                  :position position}])))}]))
